export default "__VITE_ASSET__DwfrnIkF__"